module.exports = __webpack_public_path__ + "img/projectPassword.210b218c.svg";